import React, { PureComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl';
import { Uncloak, Solicitation } from 'cloak-file-sdk-web'
import CloakSnackBar from '../components/ui/CloakSnackBar'
import { CloakUtilService } from 'cloak-file-sdk-web'

import { styled } from '@mui/system';

const StyledNavLink = styled(NavLink)(({ theme }) => ({
    color: '#1aa3ff',
    textDecoration: 'underline',
    transition: 'color 0.2s ease',
    '&:hover': {
        color: '#1792e5',
        '@media (hover: none)': {
            color: '#1792e5',
        },
    },
}));

class UncloakingPage extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            showSnackBar: false
        }

        this.handleSnackBar = this.handleSnackBar.bind(this)
    }

    componentDidMount() {
        console.log("In UncloakingPage componentDidMount")
        CloakUtilService().checkInactivityLogout(this.props)
    }

    handleSnackBar() {
        if (!this.props.token) {
            this.setState({ showSnackBar: true })
        }
    }

    render() {
        const { redirect, isUser, acceptedFile } = this.props;

        if (acceptedFile) {
            return <Navigate to="/cloak/cloak" />
        }

        if (redirect) {
            if (isUser) {
                return <Navigate to="/cloak/login" />;
            } else {
                return <Navigate to="/cloak/signup" />;
            }

        }

        return (
            <div className="clk-primary-qr-div">
                {
                    this.state.showSnackBar &&
                    <CloakSnackBar >
                        <StyledNavLink to="/cloak/qr">
                            <FormattedMessage id="cloak.mobile" values={{ process: 'Uncloaking' }} />
                        </StyledNavLink>
                    </CloakSnackBar>
                }
                <div className="clk-primary-qr clk-box-shadow ">
                    <div style={{ marginTop: 40 }}>
                        <div className="clk-main-title-div">
                            <div className="clk-main-title-text">
                                <FormattedMessage id="cloak.uncloakFile" />
                            </div>
                        </div>
                    </div>
                    <Solicitation />
                    <Uncloak onDrop={this.handleSnackBar} acceptedClkFile={this.props.acceptedClkFile} />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        redirect: state.cloak.redirect,
        isUser: state.cloak.isUser,
        token: state.auth.token,
        acceptedClkFile: state.cloak.acceptedClkFile,
        acceptedFile: state.cloak.acceptedFile
    }
};

export default connect(mapStateToProps)(UncloakingPage);
